/**
 * @generated SignedSource<<08b80c30ab736093d98419f12afea8f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SubmitContactFormInput = {
  clientMutationId: string;
  data: ReadonlyArray<ContactFormField>;
  formPageId?: string | null | undefined;
};
export type ContactFormField = {
  name: string;
  value: string;
};
export type submitContactFormMutation$variables = {
  input: SubmitContactFormInput;
};
export type submitContactFormMutation$data = {
  readonly submitContactForm: {
    readonly clientMutationId: string;
    readonly returnMessage: string;
    readonly successUrl: string | null | undefined;
  } | null | undefined;
};
export type submitContactFormMutation = {
  response: submitContactFormMutation$data;
  variables: submitContactFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SubmitContactFormPayload",
    "kind": "LinkedField",
    "name": "submitContactForm",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "successUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "returnMessage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "submitContactFormMutation",
    "selections": (v1/*: any*/),
    "type": "FundServiceMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "submitContactFormMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "026f59fb98a6660c101c8f4ad42dc035",
    "id": null,
    "metadata": {},
    "name": "submitContactFormMutation",
    "operationKind": "mutation",
    "text": "mutation submitContactFormMutation(\n  $input: SubmitContactFormInput!\n) {\n  submitContactForm(input: $input) {\n    clientMutationId\n    successUrl\n    returnMessage\n  }\n}\n"
  }
};
})();

(node as any).hash = "9a4457067876073497b1c36d5efb73e2";

export default node;
